import { GenericTableColumn } from '@shared/models/generic-table.model';

export type ThemeType = 'light' | 'dark' | 'hospital';

export type ViewType = 'table' | 'grid' | 'list';

export interface GridSettings {
  defaultView: ViewType;
  itemsPerPage: string;
  enableSorting: boolean;
  enableFiltering: boolean;
  enableColumnResize: boolean;
  enableColumnReorder: boolean;
  allowPageSizeSelection: boolean;
}

export interface AppSettings {
  theme: ThemeType;
  reducedMotion: boolean;
  highContrast: boolean;

  gridSettings: GridSettings;
  patientColumns: GenericTableColumn[];
  appointmentColumns: GenericTableColumn[];
  medicalRecordColumns: GenericTableColumn[];
}

export const DEFAULT_GRID_SETTINGS: GridSettings = {
  defaultView: 'table',
  itemsPerPage: '10',
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
  enableColumnReorder: false,
  allowPageSizeSelection: true,
};

export const DEFAULT_PATIENT_COLUMNS: GenericTableColumn[] = [
  {
    id: 'name',
    label: 'Name',
    visible: true,
    order: 1,
    sortable: true,
    copyable: true,
  },
  {
    id: 'uhid',
    label: 'UHID',
    visible: true,
    order: 2,
    sortable: true,
    copyable: true,
  },
  {
    id: 'contact',
    label: 'Email',
    visible: true,
    order: 3,
    sortable: false,
    copyable: true,
  },
  {
    id: 'ageGender',
    label: 'Age/Gender',
    visible: true,
    order: 4,
    sortable: false,
  },
  {
    id: 'bloodType',
    label: 'Blood Type',
    visible: true,
    order: 5,
    sortable: true,
  },
  {
    id: 'medicalConditions',
    label: 'Medical Conditions',
    visible: true,
    order: 6,
    sortable: false,
  },
  {
    id: 'isActive',
    label: 'Status',
    visible: true,
    order: 7,
    sortable: true,
  },
];

export const DEFAULT_APPOINTMENT_COLUMNS: GenericTableColumn[] = [
  {
    id: 'appointmentCode',
    label: 'Appointment Code',
    visible: true,
    order: 1,
    sortable: true,
    copyable: true,
  },
  {
    id: 'patientName',
    label: 'Patient',
    visible: true,
    order: 2,
    sortable: true,
  },
  {
    id: 'doctorName',
    label: 'Doctor',
    visible: true,
    order: 3,
    sortable: true,
  },
  {
    id: 'appointmentDate',
    label: 'Date',
    visible: true,
    order: 4,
    sortable: true,
  },
  {
    id: 'appointmentTime',
    label: 'Time',
    visible: true,
    order: 5,
    sortable: true,
  },
  {
    id: 'status',
    label: 'Status',
    visible: true,
    order: 6,
    sortable: true,
  },
];

export const DEFAULT_MEDICAL_RECORD_COLUMNS: GenericTableColumn[] = [
  {
    id: 'recordNumber',
    label: 'Record Number',
    visible: true,
    order: 1,
    sortable: true,
  },
  {
    id: 'patientName',
    label: 'Patient',
    visible: true,
    order: 2,
    sortable: true,
  },
  {
    id: 'doctorName',
    label: 'Doctor',
    visible: true,
    order: 3,
    sortable: true,
  },
  {
    id: 'diagnosis',
    label: 'Diagnosis',
    visible: true,
    order: 4,
    sortable: false,
  },
  {
    id: 'visitDate',
    label: 'Visit Date',
    visible: true,
    order: 5,
    sortable: true,
  },
];

export const DEFAULT_SETTINGS: AppSettings = {
  theme: 'hospital',

  reducedMotion: false,

  highContrast: false,

  gridSettings: DEFAULT_GRID_SETTINGS,

  patientColumns: DEFAULT_PATIENT_COLUMNS,

  appointmentColumns: DEFAULT_APPOINTMENT_COLUMNS,

  medicalRecordColumns: DEFAULT_MEDICAL_RECORD_COLUMNS,
};